// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ShipmentPackageDto } from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import Link from "@insite/mobius/Link";
import React, { FC } from "react";

export interface OrderLineTrackingInfoProps {
    shipmentPackages?: ShipmentPackageDto[] | null;
    orderLineId?: string;
}

const OrderLineTrackingInfo: FC<OrderLineTrackingInfoProps> = ({ shipmentPackages, orderLineId }) => {
    const orderLineTracking = shipmentPackages?.filter(element =>
        element.shipmentPackageLineDtos?.some(e => e.orderLineId === orderLineId),
    );

    return (
        <DataTable>
            <DataTableHead>
                <DataTableHeader>{translate("Service")}</DataTableHeader>
                <DataTableHeader>{translate("Tracking #")}</DataTableHeader>
            </DataTableHead>
            <DataTableBody>
                {orderLineTracking?.map(trackingItem => (
                    <DataTableRow key={trackingItem.id}>
                        <DataTableCell>{trackingItem.shipVia}</DataTableCell>
                        <DataTableCell>
                            {trackingItem.trackingUrl ? (
                                <Link href={trackingItem.trackingUrl} target="_blank">
                                    {trackingItem.trackingNumber}
                                </Link>
                            ) : (
                                trackingItem.trackingNumber
                            )}
                        </DataTableCell>
                    </DataTableRow>
                ))}
            </DataTableBody>
        </DataTable>
    );
};

export default OrderLineTrackingInfo;
